import React from 'react'

export const CreatePersonalRegisterPage = () => {
  return (
    <div>CreatePersonalRegisterPage</div>
  )
}
